import React, {PropTypes, useEffect} from 'react';
import {
  injectIntl,
  IntlProvider,
  FormattedRelative,
} from 'react-intl';

export default injectIntl(({intl}) => {
  let message = "E-Pay";
  if(window.location.hostname === "theme1.epaylocal" || window.location.hostname === "payments.schindler.com" || window.location.hostname === "payments-qa.schindler.com") message = "Schindler E-Pay";
  if(window.location.hostname === "theme1.epaylocal" || window.location.hostname === "payments.adamselevator.com" || window.location.hostname === "payments-qa.adamselevator.com") message = "Adams Elevator E-Pay";
  if(window.location.hostname === "theme2.epaylocal" || window.location.hostname === "payments.epco.us" || window.location.hostname === "payments-qa.epco.us") message = "EPCO E-Pay";
  if(window.location.hostname === "theme3.epaylocal" || window.location.hostname === "payments.republicelevator.com" || window.location.hostname === "payments-qa.republicelevator.com") message = "Republic ePay";
    if (window.location.hostname === "theme4.epaylocal" || window.location.hostname === "payments.suburbanelevator.com" || window.location.hostname === "payments-qa.suburbanelevator.com") message = "Suburban ePay";
    if (window.location.hostname === "theme5.epaylocal" || window.location.hostname === "payments.eltec.cc" || window.location.hostname === "payments-qa.eltec.cc") message = "Eltec ePay";
  
  useEffect(() => {
    document.title = message;

    const favicon = document.getElementById("favicon");
    if(window.location.hostname === "theme1.epaylocal" || window.location.hostname === "payments.schindler.com" || window.location.hostname === "payments-qa.schindler.com") favicon.href="/favicon.ico";
    if(window.location.hostname === "theme2.epaylocal" || window.location.hostname === "payments.epco.us" || window.location.hostname === "payments-qa.epco.us") favicon.href = "/epco-favicon.png";

  });
  return (
    <React.Fragment>{message}</React.Fragment>
  );
});
